import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store/index'

/**
 * jQuery
 */
window.$ = window.jQuery = require('jquery')

/**
 * Axios
 */
import axios from 'axios'
window.axios = axios

/**
 * Loadash
 * https://www.npmjs.com/package/lodash
 */
window._ = require('lodash');

/**
 * GDCE Client
 */
import backendApi from './api/backendApi'
window.GDCE_Client = backendApi

/**
 * Bootstrap
 */
require('bootstrap')

/**
 * FontAwesome
 * https://github.com/FortAwesome/vue-fontawesome
 */
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(far, fas);
Vue.component("fa", FontAwesomeIcon);


/**
 * Custom SCSS
 */
import "./assets/scss/app.scss";


/**
 * Page loading
 * https://github.com/ankurk91/vue-loading-overlay
 */
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.component('Loading', Loading)

Vue.config.productionTip = false

/**
 * https://github.com/fengyuanchen/vue-qrcode
 */
import VueQrcode from '@chenfengyuan/vue-qrcode';
Vue.component(VueQrcode.name, VueQrcode);

/**
 * Datepicker
 * https://www.npmjs.com/package/vuejs-datepicker
 */
import Datepicker from 'vuejs-datepicker'
Vue.component('datepicker', Datepicker)


/**
 * Vue XLSX: Import and Export Excel
 * https://vue-xlsx.netlify.com
 */
// import { XlsxRead, XlsxTable, XlsxSheets, XlsxJson, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx/dist/vue-xlsx.es.js"
// Vue.component({
//     XlsxRead,
//     XlsxTable,
//     XlsxSheets,
//     XlsxJson,
//     XlsxWorkbook,
//     XlsxSheet,
//     XlsxDownload
// });


/**
 * vue swal alert
 * https://github.com/anteriovieira/vue-swal
 */
import VueSwal from 'vue-swal'
Vue.use(VueSwal)

/**
 * Vue Select2
 * https://github.com/sagalbot/vue-select
 */
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

/**
 * Vue Pagination
 * https://www.npmjs.com/package/vuejs-paginate
 */
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

/**
 * Vue Simple SVG
 * https://www.npmjs.com/package/vue-simple-svg
 * https://github.com/seiyable/vue-simple-svg#readme
 */
import { SimpleSVG } from 'vue-simple-svg'
Vue.component('simple-svg', SimpleSVG)

/**
 * Translation
 * https://github.com/kazupon/vue-i18n
 */
import VueI18n from 'vue-i18n'
// import localeMessages from './localeMessages/locales' // all locale in one file
import localeMessageEn from './assets/locales/en'
import localeMessageKh from './assets/locales/kh'
import localeMessageVn from './assets/locales/vn'
import localeMessageTh from './assets/locales/th'
import localeMessageLa from './assets/locales/la'
import localeMessageCn from './assets/locales/cn'
Vue.use(VueI18n)
const locale = localStorage.getItem('locale') || 'en'
const i18n = new VueI18n({
    locale: locale, // set locale
    // messages: localeMessages, // set locales Messages for all locale in one file
    // set locales Messages separated files(Khmer and English)
    messages: { 
        en: localeMessageEn, 
        kh: localeMessageKh,
        vn: localeMessageVn,
        th: localeMessageTh,
        la: localeMessageLa,
        cn: localeMessageCn,
    },
    silentTranslationWarn: true
})

/**
 * Vee Validate
 * https://baianat.github.io/vee-validate/
 * https://www.jianshu.com/p/4d83d7c63a97
 */
import VeeValidate from 'vee-validate'
import validationMessagesEn from './assets/validators/en'
import validationMessagesKh from './assets/validators/kh'
Vue.use(VeeValidate, {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    errorBagName: 'errors',
    //events: 'input|blur|change',
    events: 'input|blur',
    fieldsBagName: 'fields',
    i18nRootKey: 'validation',
    inject: true,
    validity: false,
    locale: locale,
    i18n,
    dictionary: {
        en: validationMessagesEn,
        kh: validationMessagesKh
    }
})

/**
 * Helper
 */
import mixins from './mixins'
Vue.mixin(mixins)

/**
 * Custom Layout
 */
import Default from "./views/layouts/Default.vue"
import Blank from "./views/layouts/Blank.vue"
Vue.component('default-layout', Default)
Vue.component('blank-layout', Blank)

/**
 * Custom Components
 */
import LinkLocaleChanger from "./components/locale-changer/Link"
import DropdownLocaleChanger from "./components/locale-changer/Dropdown"
Vue.component('link-locale-changer', LinkLocaleChanger)
Vue.component('dropdown-locale-changer', DropdownLocaleChanger)

//import Vehicle from "./components/vehicle/Vehicle.vue"
import VehicleList from "./components/vehicle/List.vue"
import DriverList from "./components/driver/List.vue"
import OwnerList from "./components/owner/List.vue"
//import ViewVehicle from "./components/vehicle/View.vue"
Vue.component('vehicle-list', VehicleList)
Vue.component('driver-list', DriverList)
Vue.component('owner-list', OwnerList)
//Vue.component('vehicle', Vehicle)
//Vue.component('view-vehicle', ViewVehicle)

// import Driver from "./components/driver/Driver.vue"
// Vue.component('driver', Driver)

import Owner from "./components/owner/Owner.vue"
Vue.component('owner', Owner)
import createOwnerModal from "./components/owner/CreateModal.vue"
Vue.component('createOwnerModal', createOwnerModal)

import createVehicleModal from "./components/vehicle/CreateModal"
Vue.component('createVehicleModal', createVehicleModal)

import createDriverModal from "./components/driver/CreateModal"
Vue.component('createDriverModal', createDriverModal)

import RequiredCallout from "./components/callout/Required.vue"
Vue.component('required-callout', RequiredCallout)

import Error422 from "./components/alert/Error422.vue"
Vue.component('error-422-alert', Error422)

import WorkflowProcess from "./components/workflow/Process"
Vue.component('workflow-process', WorkflowProcess)

import ServiceSwitcher from "@/components/ServiceSwitcher.vue"
Vue.component('service-switcher', ServiceSwitcher)

import VueMask from 'v-mask'
Vue.use(VueMask);

import VueMobileDetection from "vue-mobile-detection";
Vue.use(VueMobileDetection);

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')